import React from 'react'

import CssBaseline from '@mui/material/CssBaseline'
import { ThemeProvider } from '@mui/material/styles'
import { LocalizationProvider } from '@mui/x-date-pickers-pro'
import { AdapterDayjs } from '@mui/x-date-pickers-pro/AdapterDayjs'
import { QueryClientProvider } from '@tanstack/react-query'
import { createBrowserHistory } from 'history'
import { SnackbarProvider } from 'notistack'
import { NuqsAdapter } from 'nuqs/adapters/react'
import { Provider } from 'react-redux'
import { Router } from 'react-router-dom'

import { SentryUserContext } from '@/components/core/sentry-user-context'
import { AppProvider } from '@/components/ui/app-provider'
import { constants } from '@/core/constants'
import { useScripts } from '@/hooks/use-scripts'
import { queryClient } from '@/lib/query-client'

import { RootLayout } from './containers/LayoutMain/RootLayout'
import WidgetZendesk from './containers/WidgetZendesk'
import { theme } from './muiTheme'
import { store } from './redux/configureStore'
import Routes from './routes/Routes'
import SignalRProvider from './SignalRProvider'
import AppUiProvider from './utils/AppUiProvider'

const scripts = []

if (process.env.REACT_APP_CLARITY_PROJECT_ID) {
  scripts.push({
    type: 'text/javascript',
    innerHTML: `(function(c,l,a,r,i,t,y){
c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
})(window, document, "clarity", "script", "${process.env.REACT_APP_CLARITY_PROJECT_ID}");`,
  })
}

const history = createBrowserHistory()

export default function App() {
  console.log('REACT_APP_ENV', process.env.REACT_APP_ENV)
  console.log('HOST_URL', constants.HOST_URL)

  useScripts(scripts)

  return (
    <QueryClientProvider client={queryClient}>
      <Provider store={store}>
        <SentryUserContext />
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <ThemeProvider theme={theme}>
            <CssBaseline />
            <SnackbarProvider
              maxSnack={3}
              hideIconVariant
              anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
              preventDuplicate
            >
              <NuqsAdapter>
                <Router history={history}>
                  <SignalRProvider>
                    <AppUiProvider>
                      <AppProvider>
                        <RootLayout>
                          <Routes />
                        </RootLayout>
                      </AppProvider>
                    </AppUiProvider>
                    <WidgetZendesk />
                  </SignalRProvider>
                  <div id="recaptcha" className="g-recaptcha" data-size="invisible" />
                </Router>
              </NuqsAdapter>
            </SnackbarProvider>
          </ThemeProvider>
        </LocalizationProvider>
      </Provider>
    </QueryClientProvider>
  )
}
